angular.module('iqxCore')
.controller('OwnerHomeCtrl', function ($scope, FormSvc, ApplicationSvc, ApiSvc, $window, $location, nvd3Svc) {
	moment.locale('en-gb')
	$scope.navigateToPage=function(n){$location.url(n)}


	$scope.loadDashboardSchedule=function(){
		var numToShow = 10
		$scope.currentTime = moment()
		var fetchString = 'callresult/NetOwnerDiary?pStartDate='+moment().format('YYYY-MM-DD HH:mm')+'&pEndDate='+moment().endOf("day").format('YYYY-MM-DD HH:mm')+'&pSliceSize='+numToShow
		return ApiSvc.fetch($scope,{fetchAPI:fetchString, fetchTarget:'dashboardSchedule',multiRow:true})
		.then(function(){
			angular.forEach($scope.dashboardSchedule, function(value, key){
				value.momentObjectFrom = moment(value.DiaryFrom, "DD/MM/YYYY HH:mm")
				if(value.DiaryTo && value.DiaryFrom != value.DiaryTo){
					value.momentObjectTo = moment(value.DiaryTo, "DD/MM/YYYY HH:mm")
				}
				value.startsInInfo = value.momentObjectFrom.clone().calendar(null, {
					sameDay: 'HH:mm',
					nextDay: '[tomorrow at] HH:mm',
					nextWeek: 'dddd [at] HH:mm',
					lastDay: '[Started yesterday at] HH:mm',
					lastWeek:'[Started last] dddd [at] HH:mm',
					sameElse: 'DD/MM/YYYY HH:mm'
				})
			})
			// get count
			var fetchStringCount = 'callresult/NetOwnerDiaryCount?pStartDate='+moment().format('YYYY-MM-DD HH:mm')+'&pEndDate='+moment().endOf("day").format('YYYY-MM-DD HH:mm')
			return ApiSvc.fetch($scope,{fetchAPI:fetchStringCount, fetchTarget:'dashboardScheduleCount',multiRow:false})
			.then(function(){
				$scope.dashboardScheduleNotShown = $scope.dashboardScheduleCount.count - $scope.dashboardSchedule.length
			})
		})
	}

	$scope.loadDashboardSchedule()
	nvd3Svc.fetchHomePageGraphics($scope)

})